<template>
  <MainPage>
    <form class='page-login-form register' @submit.prevent='doRegister'>
      <div class='logo-arvalis'/>
      <div class="info">
        La création d’un compte Asalée est réservée aux utilisateurs participant aux projets territoriaux et aux études mobilisant l’outil Asalée.
      </div>
      <div class='wrap'>
        <label for='email'>Email</label>
        <input v-model='email' v-focus type='email' name='email' id='email' required placeholder='Votre email' >
      </div>
      <div class='wrap'>
        <label for='nom'>Nom</label>
        <input v-model='nom' type='text' name='nom' id='nom' required placeholder='Votre nom' >
      </div>
      <div class='wrap'>
        <label for='prenom'>Prénom</label>
        <input v-model='prenom' type='text' name='prenom' id='prenom' required placeholder='Votre prénom' >
      </div>
      <div class='wrap'>
        <label for='password'>Mot de passe</label>
        <input v-model='password' type='password' name='password' id='password' required placeholder='Votre mot de passe' />
        <password-meter :password="password" />
        <span v-if="!pwdValid" class="form-error-pwd">Choisissez au moins 8 caractères dont 1 majuscule, 1 chiffre et 1 caractère spécial.</span>
      </div>
      <div class='wrap'>
        <label for='passwordConfirm'>Confirmer le mot de passe</label>
        <input v-model='passwordConfirm' type='password' name='passwordConfirm' id='passwordConfirm' required placeholder='Confirmez votre mot de passe' />
        <span v-if="password != passwordConfirm" class="form-error-pwd">Les mots de passe ne correspondent pas</span>
      </div>
      <vue-recaptcha :sitekey="siteKey" @verify="onVerify"></vue-recaptcha>
      <div class="ct-flex-row ct-jc-space">
        <input type='submit' class="primary-action" name='inscription' value="M'inscrire" :disabled="!resultCaptcha || !pwdValid || password != passwordConfirm"/>
        <input type='button' class="secondary-action" @click='retour' value="Retour" />
      </div>
    </form>
  </MainPage>
</template>

<script>
import MainPage from './MainPage'
import { mapActions, mapState } from 'vuex'
import VueRecaptcha from 'vue-recaptcha'
import passwordMeter from 'vue-simple-password-meter'

export default {
  name: 'inscription',

  components: {
    MainPage, VueRecaptcha, passwordMeter
  },

  data () {
    return {
      email: null,
      password: null,
      passwordConfirm: null,
      nom: null,
      prenom: null,
      resultCaptcha: null,
      pwdValid: false
    }
  },

  computed: mapState({
    siteKey: state => state.captchaPublicKey
  }),

  methods: {
    ...mapActions(['register']),

    onVerify (response) {
      this.resultCaptcha = response
    },

    doRegister () {
      this.register({
        nom: this.nom,
        prenom: this.prenom,
        email: this.email,
        password: this.password,
        'g-recaptcha-response': this.resultCaptcha
      })
        .then(data => {
          alert(data)
          this.$router.push({ name: 'login' })
        })
        .catch(err => {
          alert(err)
        })
    },
    retour () {
      this.$router.push({ name: 'login' })
    }
  },

  watch: {
    password: function () {
      let regexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W).{8,}$/
      this.pwdValid = regexp.test(this.password)
    }
  }
}
</script>
